import { Event } from './event'
import type { VoteDTO } from './vote.dto'
import type { VotingDTO } from './voting.dto'

export class VoteHasBeenCreated extends Event {
  static readonly type = 'VoteHasBeenCreated'

  public readonly type = VoteHasBeenCreated.type

  constructor(
    public readonly voting: VotingDTO,
    public readonly vote: VoteDTO
  ) {
    super()
  }
}
